import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  removeRow(e: MouseEvent): void {
    const row = (e.currentTarget as HTMLElement).closest('tr')
    if (row !== null) {
      row.remove()
    }
  }
}
